import { Injectable } from '@angular/core';
import { GameShow, PublicQuestionStat } from '../models/game-show.model';
import { QuizStage } from '../models/quiz-stage.model';

@Injectable({ providedIn: 'root' })
export class GameShowService {
  readonly gameShows: GameShow[] = [
    {
      id: 'quizpoker',
      title: 'Quizpoker',
      type: 'quizpoker',
      description: 'Schätzfragen, Chips, Blinds, Tipps, Setzrunden und Pot-Auszahlung.',
      status: 'In Planung',
      visibility: 'public-stats'
    },
    {
      id: 'estimate-duel',
      title: 'Schätzduell',
      type: 'estimate-duel',
      description: 'Schneller Modus für zwei Teams: Wer näher dran ist, sammelt Punkte.',
      status: 'Konzept',
      visibility: 'public-stats'
    },
    {
      id: 'bingo-lockout',
      title: 'Lockout Bingo',
      type: 'bingo-lockout',
      description: 'Bingo-Board mit gesperrten Feldern, sobald Aufgaben abgeschlossen wurden.',
      status: 'Konzept',
      visibility: 'creator-only'
    }
  ];

  readonly publicQuestionStats: PublicQuestionStat[] = [
    { category: 'Gaming', questionCount: 42, example: 'Wie viele Blöcke hat eine Minecraft-Welt ungefähr in der Breite?', difficulty: 'Gemischt' },
    { category: 'Internet & Creator', questionCount: 28, example: 'Wie viele Stunden Videomaterial werden pro Minute hochgeladen?', difficulty: 'Mittel' },
    { category: 'Allgemeinwissen', questionCount: 64, example: 'Wie hoch ist der Eiffelturm ungefähr?', difficulty: 'Einfach' },
    { category: 'Technik', questionCount: 31, example: 'Wie viele Transistoren hatte ein bekannter früher Mikroprozessor?', difficulty: 'Schwer' }
  ];

  readonly quizPokerFlow: QuizStage[] = [
    { title: 'Lobby erstellen', type: 'lobby', description: 'Creator erstellt eine Spielshow-Lobby, wählt Quizpoker und legt Startchips, Small Blind und Big Blind fest.' },
    { title: 'Creator joinen', type: 'lobby', description: 'Co-Hosts oder eingeladene Creator können per Code beitreten. Normale User sehen diesen Bereich nicht.' },
    { title: 'Schätzfrage', type: 'estimate', description: 'Die Frage kommt später aus der Datenbank. Alle aktiven Spieler geben geheim ihre Schätzung ab.' },
    { title: 'Setzrunde 1', type: 'betting', description: 'Small Blind, Big Blind, Call, Raise, Fold und All-in werden vom Backend geprüft.' },
    { title: 'Tipp 1', type: 'hint', description: 'Ein erster Hinweis wird veröffentlicht und verändert die Einschätzung.' },
    { title: 'Setzrunde 2', type: 'betting', description: 'Nach dem Tipp folgt eine weitere Setzrunde.' },
    { title: 'Tipp 2', type: 'hint', description: 'Ein weiterer Hinweis wird angezeigt.' },
    { title: 'Lösung', type: 'solution', description: 'Die echte Lösung wird gezeigt. Wer am nächsten dran ist, gewinnt den Pot.' },
    { title: 'Statistik', type: 'payout', description: 'Öffentliche Nutzer sehen nur Statistiken, Fragen-Kategorien und Auswertungen – keine Creator-Tools.' }
  ];
}
